'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('calendar-list', {
      url: '/calendar/list',
      template: '<calendar-list></calendar-list>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/calendar/list/calendar-list.routes.js